import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import CommunityEditItemDetails from "./CommunityEditItemDetails"
import CommunityEditLabelsContainer from "./CommunityEditLabelsContainer"
import CommunityViewEditorMetadata from "../view/CommunityViewEditorMetadata"
import CommunityEditRelatedContainer from "./CommunityEditRelatedContainer"
import CommunityEditHierarchyContainer from "./CommunityEditHierarchyContainer"
import CommunityEditParticipantsContainer from "./participants/CommunityEditParticipantsContainer"

const CommunityEditItem = ({
    model,
    participantType,
    isAdding,
    communityId,
    onEventChange,
    onValueChange,
    onImageChange
}) => (
    <ItemDetailsColumns>
        <ItemDetailsColumn>
            <CommunityEditItemDetails
                name={model.name}
                description={model.description}
                status={model.status}
                privacy={model.privacy}
                imageUrl={model.image_url}
                openFeed={model.open_feed}
                imagePreviewURL={model.imagePreviewURL}
                onEventChange={onEventChange}
                onValueChange={onValueChange}
                onImageChange={onImageChange}
            />
            <CommunityEditLabelsContainer onValueChange={onValueChange} />
            <CommunityViewEditorMetadata
                creator={model.creator}
                time={model.time}
                source={model.source}
                updatedBy={model.updated_by}
                lastUpdated={model.last_updated}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <CommunityEditHierarchyContainer
                onEventChange={onEventChange}
                onValueChange={onValueChange}
            />
            <CommunityEditRelatedContainer
                onEventChange={onEventChange}
                onValueChange={onValueChange}
            />
            <div className="community-participants-panel">
                <CommunityEditParticipantsContainer
                    type={participantType}
                    communityId={communityId}
                    isAdding={isAdding}
                />
            </div>
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default CommunityEditItem
